(function () {
  if (window.__meshkiAuHomeLoaded) return;
  window.__meshkiAuHomeLoaded = true;

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-mk-tab]');
    if (tab) {
      var section = tab.closest('[data-mk-tabs]');
      if (!section) return;
      var key = tab.getAttribute('data-mk-tab');
      section.querySelectorAll('[data-mk-tab]').forEach(function (item) {
        var active = item.getAttribute('data-mk-tab') === key;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      section.querySelectorAll('[data-mk-panel]').forEach(function (panel) {
        var active = panel.getAttribute('data-mk-panel') === key;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      return;
    }

    var arrow = event.target.closest('[data-mk-scroll]');
    if (!arrow) return;
    var carousel = arrow.closest('[data-mk-carousel]');
    var track = carousel && carousel.querySelector('[data-mk-track]:not([hidden])');
    if (!track) return;
    var direction = Number(arrow.getAttribute('data-mk-scroll')) || 1;
    track.scrollBy({ left: track.clientWidth * 0.92 * direction, behavior: 'smooth' });
  });
})();
